import React, { useState } from 'react';
import { ExternalLinkIcon, PlusIcon, Trash2Icon } from 'lucide-react';
import { useAppState } from '../../contexts/AppStateContext';
import { copy } from '../../data/copy';
import { Button } from '../ui/Button';
import { EmptyNote } from '../ui/Panel';
import { GoalCard } from '../progress/GoalCard';
export function GoalAndWishes() {
  const {
    db,
    family,
    memberById,
    viewer,
    isAdmin,
    addWish,
    removeWish,
    setGoal
  } = useAppState();
  const wishes = db.wishes.filter(w => w.familyId === family.id);
  const [title, setTitle] = useState('');
  const [link, setLink] = useState('');
  return <div className="grid gap-6 lg:grid-cols-2" data-id="element-138" data-mp="1vj7gb6jo5cwa">
      <div className="space-y-3" data-id="element-139" data-mp="1vftbzsrg2tm7">
        {family.goal ? <GoalCard data-id="element-140" data-mp="1rhvkgja7bvfn" /> : <EmptyNote data-id="element-141" data-mp="1rer9n328e1g0">Družina še nima skupnega cilja.</EmptyNote>}
        {isAdmin && !family.goal && <Button variant="secondary" onClick={() => setGoal({
        title: 'Družinski izlet',
        reward: 'Skupni dan po izbiri',
        target: 300,
        current: 0
      })} data-id="element-142" data-mp="1hiegq7eifrmb">
            <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-143" data-mp="1z8cpjepq4g2g" /> Nastavi skupni cilj
          </Button>}
      </div>
      <div data-id="element-144" data-mp="241z1t5rz6hxq">
        <h3 className="font-display text-lg font-semibold" data-id="element-145" data-mp="241pclker8et3">Želje za izlete in počitnice</h3>
        <p className="text-xs text-muted" data-id="element-146" data-mp="1q6d7qk6vx7yg">Preprost seznam za motivacijo. Načrt, proračun, pakiranje in fotografije pridejo v poznejšem modulu Izleti.</p>
        <form className="mt-3 grid gap-2 sm:grid-cols-[1fr_1fr_auto]" onSubmit={e => {
        e.preventDefault();
        if (!title.trim()) return;
        addWish(title.trim(), undefined, link.trim() || undefined);
        setTitle('');
        setLink('');
      }} data-id="element-147" data-mp="2iy6kg1nqjbaw">
          <input className="field" aria-label="Želja" placeholder="Kam bi šli?" value={title} onChange={e => setTitle(e.target.value)} data-id="element-148" data-mp="2dw7gapk68acw" />
          <input className="field" aria-label="Povezava" placeholder="Povezava (neobvezno)" value={link} onChange={e => setLink(e.target.value)} data-id="element-149" data-mp="12ilt39xvgiu0" />
          <Button type="submit" disabled={!title.trim()} data-id="element-150" data-mp="ig957xmr4mwb">
            Dodaj
          </Button>
        </form>
        {wishes.length === 0 ? <div className="mt-3" data-id="element-151" data-mp="9ogx3tl79puw">
            <EmptyNote data-id="element-152" data-mp="9nfaqsyqhgxv">{copy.emptyWishes}</EmptyNote>
          </div> : <ul className="mt-3 divide-y divide-line rounded-3xl border-[1.5px] border-line bg-surface" data-id="element-153" data-mp="4pvx9v9v186z">
            {wishes.map(w => <li key={w.id} className="flex items-center gap-3 px-4 py-3" data-id="element-154" data-mp="3vx8gsgy7txq2">
                <span className="min-w-0 flex-1" data-id="element-155" data-mp="3qvj3eunit7yt">
                  <span className="block font-bold" data-id="element-156" data-mp="3qyx6y67x7n7u">{w.title}</span>
                  <span className="block text-xs text-muted" data-id="element-157" data-mp="3mvioza0f8wrr">
                    predlaga {memberById(w.addedBy)?.name}
                    {w.note ? ` · ${w.note}` : ''}
                  </span>
                </span>
                {w.link && <a href={w.link} target="_blank" rel="noreferrer" aria-label={`Odpri povezavo: ${w.title}`} className="grid h-9 w-9 place-items-center rounded-xl text-info-ink hover:bg-canvas" data-id="element-158" data-mp="1g4sonbtio9hi">
                    <ExternalLinkIcon className="h-4 w-4" data-id="element-159" data-mp="1smvdh30ve99d" />
                  </a>}
                {(isAdmin || w.addedBy === viewer.id) && <button type="button" onClick={() => removeWish(w.id)} aria-label={`Odstrani ${w.title}`} className="grid h-9 w-9 place-items-center rounded-xl text-muted hover:bg-canvas" data-id="element-160" data-mp="1xen5lhzocn1m">
                    <Trash2Icon className="h-4 w-4" data-id="element-161" data-mp="14qr13r3v5qua" />
                  </button>}
              </li>)}
          </ul>}
      </div>
    </div>;
}